<script setup lang="ts">
import { SiteFooter, SiteHeader } from "@/shared/ui";
</script>

<template>
  <SiteHeader />
  <main id="main" class="site-main">
    <RouterView />
  </main>
  <SiteFooter />
</template>

<style scoped>
.site-main {
  min-height: calc(100vh - 200px);
  padding-bottom: var(--rv-space-16);
}
</style>
